import React from 'react';
import { Button } from './Button';

const SuccessButton = (props) => <Button {...props} bsStyle="btn-success" />;

SuccessButton.displayName = 'SuccessButton';

export default SuccessButton;
